import ApiService from '../../../../../../services/ApiService'

export default {
  props: {
    filterProp: Object,
  },
  components: {},
  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      page: 1,
      showChart: true,
      total: 0,
      totalPages: 1,
      pageSize: 7,
      costs: [],
      expanded: [],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      header: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Equipamento',
          align: 'center',
          value: 'equipmentName',
        },
        {
          text: 'Nº Identificação',
          align: 'center',
          value: 'identification',
        },
        {
          text: 'Modelo',
          align: 'center',
          value: 'model',
        },
        {
          text: 'Fabricante',
          align: 'center',
          value: 'manufacturer',
        },
        {
          text: 'Custo por peça',
          align: 'center',
          value: 'totalPieceCosts',
        },
        {
          text: 'Custo por Serviço Externo',
          align: 'center',
          value: 'totalExternalServiceCosts',
        },
        {
          text: 'Custo por Contrato',
          align: 'center',
          value: 'totalContractValue',
        },
        {
          text: 'Custo Mão-de-obra Interna',
          align: 'center',
          value: 'totalServiceCost',
        },
        {
          text: 'Custo Total',
          align: 'center',
          value: 'totalValue',
        },
      ],
      headerMobile: [
        {
          text: 'Nº Identificação',
          align: 'center',
          value: 'identification',
        },
        {
          text: 'Custo Total',
          align: 'center',
          value: 'totalValue',
        },
      ],
      total: 0,
    }
  },
  async created() {
    this.listCostPerEquipment()
  },
  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `cost_Period_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('excel/costPeriod', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    async listCostPerEquipment() {
      await this.apiService
        .post('reports/listCostsEquipment', this.filterProp)
        .then((response) => {
          this.costs = []
          this.total = response.content.pager.totalItems
          this.showChart = response.content.objects.length > 0
          this.costs = response.content.objects
          this.totalPages = response.content.pager.totalPages
        })
        .catch((err) => {})
    },
    formatCurrency(value) {
      if (value) {
        const stringValue = value.toFixed(2)
        const parts = stringValue.split('.')
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        return `$${parts.join(',')}`
      } else {
        return '$0,00'
      }
    },
  },
  watch: {
    page() {
      this.filterProp.page = this.page
      this.listCostPerEquipment()
    },
  },
}
